import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/images/service/service-icon-2.png'


const _hoisted_1 = { class: "service-wrap pt-100 pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "service-card style1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "service-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Image"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CategorieArticles, (categorieArticle) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xxl-3 col-xl-4 col-lg-6 col-md-6",
            key: categorieArticle.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h3", null, [
                (categorieArticle.lienExterne)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: categorieArticle.lienExterne
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categorieArticle.nom), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "#"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categorieArticle.nom), 1)
                      ]),
                      _: 2
                    }, 1024))
              ]),
              _createElementVNode("p", null, _toDisplayString((categorieArticle.description.length > 25) ? categorieArticle.description.substring(0, 90) + '...' : categorieArticle.description), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}